import styled from '@emotion/styled'

import Elevation from '@segment/matcha/components/Elevation'
import Image from '@segment/matcha/components/Image'

import realTimeAudiencesPng2x from './assets/RealTimeAudience@2x.png'
import realTimeAudiencesWebp from './assets/RealTimeAudience.webp'
import realTimeAudiencesWebp2x from './assets/RealTimeAudience@2x.webp'

const RealTimeAudiencesImage = () => {
  return (
    <StyledElevation elevation={4}>
      <picture>
        <source type="image/webp" srcSet={`${realTimeAudiencesWebp}, ${realTimeAudiencesWebp2x} 2x`} />
        <Image src={realTimeAudiencesPng2x} alt="Real-time audiences" width="640" height="534" loading="lazy" />
      </picture>
    </StyledElevation>
  )
}

const StyledElevation = styled(Elevation)`
  border: 2px solid ${({ theme }) => theme.palette.twilio.gray[20]};
  border-radius: 8px;
`

export default RealTimeAudiencesImage
